var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Box, Container, Divider, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import IconLinkedIn from '../../../assets/images/frontend-pages/icons/icon-linkedin.svg';
import LogoIcon from '../../../components/logos/logoIcon.svg';
import { appUrls } from "../../../urls";
var footerLinks = [
    {
        id: 1,
        children: [
            {
                title: true,
                titleText: 'Solutions',
            },
            {
                title: false,
                titleText: 'Document Review',
                link: appUrls.FREE_ANALYSIS,
            },
        ],
    },
    {
        id: 2,
        children: [
            {
                title: true,
                titleText: 'Legal',
            },
            {
                title: false,
                titleText: 'Terms of service',
                link: appUrls.TERMS_CONDITIONS,
            },
            {
                title: false,
                titleText: 'Privacy policy',
                link: appUrls.PRIVACY,
            },
        ],
    },
    {
        id: 3,
        children: [
            {
                title: true,
                titleText: 'About',
            },
            {
                title: false,
                titleText: 'About us',
                link: appUrls.ABOUT,
            },
            {
                title: false,
                titleText: 'Contacts',
                link: appUrls.CONTACT_US,
            },
        ],
    },
];
var Footer = function () {
    return (_jsx(_Fragment, { children: _jsxs(Container, __assign({ maxWidth: "lg", sx: {
                pt: {
                    xs: '30px',
                    lg: '60px',
                },
            } }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 3, justifyContent: "space-between", mb: 7 }, { children: [footerLinks.map(function (footerlink, i) {
                            var _a;
                            return (_jsx(Grid, __assign({ item: true, xs: 6, sm: 4, lg: 2 }, { children: (_a = footerlink.children) === null || _a === void 0 ? void 0 : _a.map(function (child, j) { return (_jsx(React.Fragment, { children: child.title ? (_jsx(Typography, __assign({ fontSize: "17px", fontWeight: "600", mb: "22px" }, { children: child.titleText }))) : (_jsx(NavLink, __assign({ to: child.link || '/', style: function (_a) {
                                            var isActive = _a.isActive;
                                            return ({
                                                display: 'block',
                                                padding: '10px 0',
                                                fontSize: '15px',
                                                color: isActive ? '#5D87FF' : '#000000',
                                                fontWeight: isActive ? '600' : '400',
                                                textDecoration: 'none',
                                            });
                                        } }, { children: child.titleText }))) }, j)); }) }), i));
                        }), _jsxs(Grid, __assign({ item: true, xs: 6, sm: 6, lg: 2 }, { children: [_jsx(Typography, __assign({ fontSize: "17px", fontWeight: "600", mb: "22px" }, { children: "Follow us" })), _jsx(Stack, __assign({ direction: "row", gap: "20px" }, { children: _jsx(Tooltip, __assign({ title: "LinkedIn" }, { children: _jsx(NavLink, __assign({ to: "https://www.linkedin.com/company/justee-ai/" }, { children: _jsx("img", { src: IconLinkedIn, alt: "LinkedIn", width: 22, height: 22 }) })) })) }))] }))] })), _jsx(Divider, {}), _jsx(Box, __assign({ py: "40px", flexWrap: "wrap", display: "flex", justifyContent: "space-between" }, { children: _jsxs(Stack, __assign({ direction: "row", gap: 1, alignItems: "center" }, { children: [_jsx("img", { src: LogoIcon, width: 20, height: 20, alt: "logo" }), _jsxs(Typography, __assign({ variant: "body1", fontSize: "15px" }, { children: ["\u00A9 ", new Date().getFullYear(), " Justee. All rights reserved."] }))] })) }))] })) }));
};
export default Footer;
